module.exports = __webpack_public_path__ + "static/media/Values_Icon.0c556b9b.svg";